import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { API } from "@/lib/api";

const YEAR = 2026;

export default function StatsSection() {
  const [stats, setStats] = useState({ total: 0, dikabulkan: 0, ditolak: 0 });

  useEffect(() => {
    fetch(`${API}/api/public/permohonan/stats?year=${YEAR}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d)
          setStats({
            total: d.total || 0,
            dikabulkan: d.dikabulkan || 0,
            ditolak: d.ditolak || 0,
          });
      })
      .catch(() => {});
  }, []);

  const items = [
    { testid: "stat-total", label: "JUMLAH TOTAL PERMOHONAN", value: stats.total },
    { testid: "stat-dikabulkan", label: "PERMOHONAN DIKABULKAN", value: stats.dikabulkan },
    { testid: "stat-ditolak", label: "PERMOHONAN DITOLAK", value: stats.ditolak },
  ];

  return (
    <section
      data-testid="stats-section"
      className="bg-[#0B2440] px-6 py-20 text-white md:px-12 md:py-24"
    >
      <Reveal>
        <h2 className="mx-auto max-w-3xl text-center font-display text-2xl font-semibold leading-snug md:text-4xl">
          Jumlah Permohonan Informasi Publik
          <span className="mt-1 block text-[#8FC4E8]">Tahun {YEAR}</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mx-auto mt-12 grid max-w-5xl gap-5 sm:grid-cols-3">
          {items.map((s) => (
            <div
              key={s.testid}
              data-testid={s.testid}
              className="rounded-3xl border border-white/15 bg-white/5 px-6 py-8 text-center"
            >
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8FC4E8]">
                {s.label}
              </p>
              <p className="mt-4 font-display text-4xl font-semibold md:text-5xl">
                {s.value}
              </p>
              <p className="mt-1 text-xs font-medium text-white/70">Permohonan</p>
            </div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 flex justify-center">
          <Link
            to="/data-permohonan"
            data-testid="stats-selengkapnya-button"
            className="inline-flex items-center justify-center rounded-full bg-[#1479BF] px-8 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-white hover:text-[#0B2440]"
          >
            LIHAT SELENGKAPNYA
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
